import { Alert } from '@material-ui/lab';
import styled from '@emotion/styled';
import React from 'react';

const AlertStyled = styled(Alert)`
  border: 1px solid #f7e1ca;
  font-size: 1rem;
  margin-bottom: 2.5rem;
`;

const AlertMessage = ({ children, severity, icon, ...props }) => {
  return (
    <AlertStyled severity={severity} icon={icon} {...props}>
      {children}
    </AlertStyled>
  );
};

export { AlertMessage };
